import { Input } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

import { usePostReplyWithCacheUpdate } from "./usePostReplyWithCacheUpdate";

interface InlineReplyInputProps {
  workplaceId: string;
  parentId: string;
  workerFullName: string;
}

export function InlineReplyInput(props: InlineReplyInputProps) {
  const { workplaceId, parentId, workerFullName } = props;

  const { postReply, isPostingReply, text, setText } = usePostReplyWithCacheUpdate({
    workplaceId,
    parentId,
  });

  return (
    <Stack
      sx={(theme) => ({
        px: 7,
        py: 4,
        borderTop: `1px solid ${theme.palette.divider}`,
      })}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Input
          placeholder={`Comment as ${workerFullName}...`}
          value={text}
          sx={{ paddingRight: text ? 12 : undefined }}
          onChange={(event) => {
            setText(event.target.value);
          }}
        />
        {text && (
          <Box
            sx={{
              position: "absolute",
              right: 4,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <IconButton
              iconType="navigation-arrow"
              variant="ghost"
              size="small"
              disabled={isPostingReply}
              onClick={() => {
                postReply({ text, parentId });
              }}
            />
          </Box>
        )}
      </Box>
    </Stack>
  );
}
